import { useTranslation } from 'react-i18next'

import { OrderResponseItem } from '../../data/models'

export const DateBodyTemplate = (
  date?: string | Date,
  confirmationCode?: OrderResponseItem['ConfirmationCode'],
  includeTime?: boolean,
) => {
  const { i18n } = useTranslation()
  const { language } = i18n

  if (!date) return null

  // format date
  function formatDate(dateString: string | Date) {
    const dateObject = new Date(dateString)

    let dateOptions: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    }

    if (includeTime) {
      dateOptions = {
        ...dateOptions,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }
    }

    const formattedDate = dateObject.toLocaleDateString(language, dateOptions)

    return formattedDate
  }

  // Don't show the date if …
  // - the item was rejected
  // - no date is available or
  if (confirmationCode === 'REJECTED' || !date) {
    return <></>
  }

  // Otherwise show a formatted date
  return <>{formatDate(date)}</>
}
